import { render, staticRenderFns } from "./NarrativeBlock.vue?vue&type=template&id=5dac81ca&scoped=true&"
import script from "./NarrativeBlock.vue?vue&type=script&lang=js&"
export * from "./NarrativeBlock.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeBlock.vue?vue&type=style&index=0&id=5dac81ca&lang=scss&scoped=true&"
import style1 from "./NarrativeBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dac81ca",
  null
  
)

export default component.exports